import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";
import { NavigationGroup } from "@/types/navigation";

type SecondaryNavigationProps = {
  navigations: NavigationGroup[];
};

export function SecondaryNavigation({ navigations }: SecondaryNavigationProps) {
  return (
    <nav className="flex flex-1 flex-col">
      <ul role="list" className="flex flex-1 flex-col gap-y-7">
        {navigations.map((navigation, index) => (
          <li key={navigation.name ?? index}>
            {navigation.name && (
              <p className="flex items-center gap-x-2 p-2 text-sm font-semibold text-card-foreground">
                {navigation.icon && (
                  <navigation.icon
                    aria-hidden="true"
                    className="h-4 w-4 shrink-0 text-inherit"
                  />
                )}
                {navigation.name}
              </p>
            )}
            <ul role="list">
              {navigation.elements.map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      cn(
                        isActive
                          ? "border-border bg-card text-primary"
                          : "border-transparent text-muted hover:text-foreground",
                        "text-md block rounded-sm border p-2 font-semibold leading-6",
                        item.disabled &&
                          "pointer-events-none cursor-not-allowed opacity-30",
                      )
                    }
                  >
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
}
